import { FC } from "react";
import { Redeem } from "@mui/icons-material";

import { useMetamask, useWriteContractWithSimulation } from "@dzambalaorg/react-hooks-eth";
import { ListAction, ListActionVariant } from "@framework/styled";
import { AddressType, type IBalance, TokenType } from "@framework/types";
import VestingReleaseABI from "@framework/abis/json/Vesting/release.json";

export interface IVestingReleaseButtonProps {
  balance: IBalance;
  className?: string;
  disabled?: boolean;
  variant?: ListActionVariant;
}

export const VestingReleaseButton: FC<IVestingReleaseButtonProps> = props => {
  const { balance, className, disabled, variant } = props;

  const { writeContractAsync } = useWriteContractWithSimulation();

  const { execute: metaRelease } = useMetamask(async (vesting: IBalance) => {
    if (balance.token?.template?.contract?.contractType === TokenType.ERC20) {
      return writeContractAsync({
        address: vesting.account as AddressType,
        abi: VestingReleaseABI,
        functionName: "release",
        args: [balance.token?.template.contract.address],
      });
    } else if (balance.token?.template?.contract?.contractType === TokenType.NATIVE) {
      // https://ethereum.stackexchange.com/questions/132850/incorrect-gaslimit-estimation-for-transaction
      return writeContractAsync({
        address: vesting.account as AddressType,
        abi: VestingReleaseABI,
        functionName: "release",
        args: [],
      });
    } else {
      throw new Error("unsupported token type");
    }
  });

  const handleClick = () => {
    return metaRelease(balance);
  };

  return (
    <ListAction
      onClick={handleClick}
      icon={Redeem}
      message="form.tips.release"
      className={className}
      dataTestId="VestingReleaseButton"
      disabled={disabled || balance.amount === "0"}
      variant={variant}
    />
  );
};
